export function debounce(fn, delay) {
  let timer
  return function (...args) {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), delay)
  }
}

export function debouncePromise(fn, delay) {
  let timer;
  return function(...args) {
    return new Promise((resolve, reject) => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        fn(...args).then(resolve).catch(reject);
      }, delay);
    });
  };
}